import { render, staticRenderFns } from "./card-pax.vue?vue&type=template&id=08b82c7e&scoped=true&"
import script from "./card-pax.vue?vue&type=script&lang=js&"
export * from "./card-pax.vue?vue&type=script&lang=js&"
import style0 from "./card-pax.vue?vue&type=style&index=0&id=08b82c7e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08b82c7e",
  null
  
)

export default component.exports